// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2mOuI","title":"FrontImage_title__1F-D7"};